import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PersonalDataBlockContainer from "containers/molecules/PersonalDataBlockContainer";
import { useBreakpoint } from "hooks/useBreakpoint";
import PageTitle from "components/atoms/PageTitle";
import { makeLangUrl } from "helpers/makeLangUrl";
import url from "../../../../url";
import "./styles.sass";

const PersonalMobile = () => {
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(makeLangUrl("/profile"));
  };

  useEffect(() => {
    if (isDesktop) {
      navigate(url.routes.profile.index());
    }
  }, [isDesktop, navigate]);

  return (
    <div className="PersonalMobile">
      <PageTitle title="profile.account.header" onBack={handleBack} />
      <PersonalDataBlockContainer />
    </div>
  );
};

export default PersonalMobile;
